"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ProductIdentifier = ({
  value,
  className,
  prefix,
  label,
  subtle,
  ...other
}) => {
  const classes = (0, _classnames.default)(`${prefix}product-identifier`, className, subtle && `${prefix}product-identifier--subtle`);
  return _react.default.createElement("span", _extends({
    "x-ms-format-detection": "none",
    className: classes
  }, other), label && _react.default.createElement("span", {
    className: `${prefix}product-identifier__label`
  }, label), _react.default.createElement("span", {
    className: `${prefix}product-identifier__value`
  }, value));
};

ProductIdentifier.defaultProps = {
  value: '123.456.78',
  prefix: ''
};
var _default = ProductIdentifier;
exports.default = _default;